import { action, makeAutoObservable } from "mobx";
import CommonStore from "../../../../stores/CommonStore";
import { AffectedPrice } from "../NewArticleSalePriceButtonStore";

class UpdateChildrenArticlePriceStore {
    public articleId: string;
    public salePriceId: string;
    public deliveryTimeDays: number | undefined;
    public affectedPrices: AffectedPrice[];
    public newValueDifference: number;
    
    public loading: boolean = false;
    public commonStore: CommonStore;
    public error?: string;

    constructor(
        commonStore: CommonStore,
        articleId: string,
        salePriceId: string,
        deliveryTimeDays: number | undefined,
        affectedPrices: AffectedPrice[],
        newValueDifference: number
    ) {
        this.articleId = articleId;
        this.salePriceId = salePriceId;
        this.deliveryTimeDays = deliveryTimeDays;
        this.newValueDifference = newValueDifference;
        this.commonStore = commonStore;
        this.affectedPrices = affectedPrices;
        makeAutoObservable(this);
    }

    

    @action
    public togglePriceSelection(agencyId: string) {
        const price = this.affectedPrices.find(p => p.agencyId === agencyId);
        if (price) {
            price.isSelected = !price.isSelected;
        }
    }

    @action
    public getSelectedPrices(): AffectedPrice[] {
        return this.affectedPrices.filter(p => p.isSelected);
    }

    @action
    public getTotalAffected(): number {
        return this.affectedPrices.length;
    }

    @action
    public getTotalSelected(): number {
        return this.affectedPrices.filter(p => p.isSelected).length;
    }
}

export default UpdateChildrenArticlePriceStore;
